// ============================================
// FOOTER COMPONENT - Complete with All Links
// ============================================

import React from 'react';
import { Link } from 'react-router-dom';
import { MdDescription, MdEmail } from 'react-icons/md';
import { FaTwitter, FaLinkedin, FaGithub, FaFacebook } from 'react-icons/fa';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-lg flex items-center justify-center">
                <MdDescription className="w-5 h-5 text-white" />
              </div>
              <span className="text-lg font-bold text-white">ATS Resume Builder</span>
            </Link>
            <p className="text-sm text-gray-400 mb-4">
              Create professional, ATS-friendly resumes with AI-powered optimization. 
              Land more interviews with a resume that passes applicant tracking systems.
            </p>
            <div className="flex gap-3">
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="p-2 bg-gray-800 hover:bg-gray-700 rounded-lg transition-colors" aria-label="Twitter">
                <FaTwitter className="w-4 h-4" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="p-2 bg-gray-800 hover:bg-gray-700 rounded-lg transition-colors" aria-label="LinkedIn">
                <FaLinkedin className="w-4 h-4" />
              </a>
              <a href="https://github.com/Dantech-Mwa/ats-resume-builder" target="_blank" rel="noopener noreferrer" className="p-2 bg-gray-800 hover:bg-gray-700 rounded-lg transition-colors" aria-label="GitHub">
                <FaGithub className="w-4 h-4" />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="p-2 bg-gray-800 hover:bg-gray-700 rounded-lg transition-colors" aria-label="Facebook">
                <FaFacebook className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Product */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Product</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/#features" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Features
                </Link>
              </li>
              <li>
                <Link to="/templates" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Templates
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/sample-resumes" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Sample Resumes
                </Link>
              </li>
              <li>
                <Link to="/career-blog" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Career Blog
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Resources</h3>
            <ul className="space-y-2">
              <li>
                <Link to="resume-guide" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Resume Writing Guide
                </Link>
              </li>
              <li>
                <Link to="ats-tips" className="text-sm text-gray-400 hover:text-white transition-colors">
                  ATS Optimization Tips
                </Link>
              </li>
              <li>
                <Link to="/career-blog?tab=jobs" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Job Board
                </Link>
              </li>
              <li>
                <Link to="/sample-resumes" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Sample Resumes
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-sm text-gray-400 hover:text-white transition-colors">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Company</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-gray-400 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/career-blog?tab=jobs" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Careers
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              &copy; {currentYear} ATS Resume Builder. All rights reserved.
            </p>
            <div className="flex items-center gap-2 text-sm text-gray-400">
              <MdEmail className="w-4 h-4" />
              <a href="mailto:wambuamwanza6@gmail.com" className="hover:text-white transition-colors">
                wambuamwanza6@gmail.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
